if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.prevButton = this.querySelector('.product-media-modal__nav--prev');
      this.nextButton = this.querySelector('.product-media-modal__nav--next');
      this.mediaContent = this.querySelector('.product-media-modal__content');
      this.swipeStartX = null;
      this.swipeStartY = null;
      [this.prevButton, this.nextButton].forEach((button) => {
        button?.addEventListener('pointerup', (event) => event.stopPropagation());
        button?.addEventListener('click', (event) => event.stopPropagation());
      });
      this.prevButton?.addEventListener('click', this.showPreviousMedia.bind(this));
      this.nextButton?.addEventListener('click', this.showNextMedia.bind(this));
      this.mediaContent?.addEventListener('pointerdown', this.handleSwipeStart.bind(this));
      this.mediaContent?.addEventListener('pointerup', this.handleSwipeEnd.bind(this));
      this.mediaContent?.addEventListener('pointercancel', this.resetSwipe.bind(this));
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      this.activateMedia(activeMedia);
    }

    activateMedia(activeMedia) {
      if (!activeMedia) return;

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      this.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('active');
      });
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView({ block: 'center', inline: 'center' });
      const container = this.querySelector('[role="document"]');
      if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();

      this.updateNavigation(activeMedia);
    }

    handleSwipeStart(event) {
      this.swipeStartX = event.clientX;
      this.swipeStartY = event.clientY;
    }

    handleSwipeEnd(event) {
      if (this.swipeStartX === null || this.swipeStartY === null) {
        this.resetSwipe();
        return;
      }

      const deltaX = event.clientX - this.swipeStartX;
      const deltaY = event.clientY - this.swipeStartY;
      this.resetSwipe();

      if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY)) return;

      if (deltaX < 0) {
        this.showNextMedia();
      } else {
        this.showPreviousMedia();
      }
    }

    resetSwipe() {
      this.swipeStartX = null;
      this.swipeStartY = null;
    }

    getMediaItems() {
      return Array.from(this.querySelectorAll('[data-media-id]'));
    }

    getActiveMediaIndex() {
      return this.getMediaItems().findIndex((item) => item.classList.contains('active'));
    }

    showPreviousMedia() {
      this.showMediaByDirection(-1);
    }

    showNextMedia() {
      this.showMediaByDirection(1);
    }

    showMediaByDirection(direction) {
      const mediaItems = this.getMediaItems();
      if (!mediaItems.length) return;

      const activeIndex = this.getActiveMediaIndex();
      const nextIndex = (activeIndex + direction + mediaItems.length) % mediaItems.length;
      this.activateMedia(mediaItems[nextIndex]);
    }

    updateNavigation(activeMedia) {
      const mediaItems = this.getMediaItems();
      const hasMultipleMedia = mediaItems.length > 1;

      if (!this.prevButton || !this.nextButton) return;

      this.prevButton.toggleAttribute('disabled', !hasMultipleMedia);
      this.nextButton.toggleAttribute('disabled', !hasMultipleMedia);
      this.prevButton.setAttribute('aria-hidden', String(!hasMultipleMedia));
      this.nextButton.setAttribute('aria-hidden', String(!hasMultipleMedia));
    }
  });
}
